import React, { useEffect, useState } from 'react';
import { BootstrapContextProvider } from './BootstrapContext';
import { useHandleBoostrapProvider } from './hooks/useHandleBoostrapProvider';
import ContentLoader from 'containers/Player/components/ContentLoader';

const BoostrapProvider = ({ children }) => {
  const [isAppReady, setIsAppReady] = useState(false);
  const [isLinealChannelReady, setIsLinealChannelReady] = useState(false)
  const {
    boot,
    shiModel,
    configModel,
    metadataModel,
    assetModel,
  } = useHandleBoostrapProvider();

  useEffect(() => {
    boot();
  }, []);

  if (shiModel && configModel && metadataModel && assetModel)
    return (
      <BootstrapContextProvider
        value={{
          shiModel: shiModel,
          configModel: configModel,
          metadataModel: metadataModel,
          assetModel: assetModel,
          reboot: async cb => boot(cb),
          isAppReady, 
          setIsAppReady,
          isLinealChannelReady,
          setIsLinealChannelReady,
        }}
      >
        {children}
      </BootstrapContextProvider>
    );
  return <ContentLoader />;
};

export default BoostrapProvider;
